module.exports = CCWA_CONFIG;